// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function product_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var code = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "code"), null));
  if (code.TAG === /* Ok */0) {
    var name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "name"), null));
    if (name.TAG === /* Ok */0) {
      var description = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "description"), null));
      if (description.TAG === /* Ok */0) {
        var is_active = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "is_active"), null));
        if (is_active.TAG === /* Ok */0) {
          var list_amount_minor = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "list_amount_minor"), null));
          if (list_amount_minor.TAG === /* Ok */0) {
            var sale_amount_minor = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "sale_amount_minor"), null));
            if (sale_amount_minor.TAG === /* Ok */0) {
              var currency_code = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "currency_code"), null));
              if (currency_code.TAG === /* Ok */0) {
                var created_at = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "created_at"), null));
                if (created_at.TAG === /* Ok */0) {
                  var updated_at = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "updated_at"), null));
                  if (updated_at.TAG === /* Ok */0) {
                    return {
                            TAG: /* Ok */0,
                            _0: {
                              code: code._0,
                              name: name._0,
                              description: description._0,
                              is_active: is_active._0,
                              list_amount_minor: list_amount_minor._0,
                              sale_amount_minor: sale_amount_minor._0,
                              currency_code: currency_code._0,
                              created_at: created_at._0,
                              updated_at: updated_at._0
                            }
                          };
                  }
                  var e = updated_at._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: ".updated_at" + e.path,
                            message: e.message,
                            value: e.value
                          }
                        };
                }
                var e$1 = created_at._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".created_at" + e$1.path,
                          message: e$1.message,
                          value: e$1.value
                        }
                      };
              }
              var e$2 = currency_code._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".currency_code" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                      }
                    };
            }
            var e$3 = sale_amount_minor._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".sale_amount_minor" + e$3.path,
                      message: e$3.message,
                      value: e$3.value
                    }
                  };
          }
          var e$4 = list_amount_minor._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".list_amount_minor" + e$4.path,
                    message: e$4.message,
                    value: e$4.value
                  }
                };
        }
        var e$5 = is_active._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".is_active" + e$5.path,
                  message: e$5.message,
                  value: e$5.value
                }
              };
      }
      var e$6 = description._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".description" + e$6.path,
                message: e$6.message,
                value: e$6.value
              }
            };
    }
    var e$7 = name._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".name" + e$7.path,
              message: e$7.message,
              value: e$7.value
            }
          };
  }
  var e$8 = code._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".code" + e$8.path,
            message: e$8.message,
            value: e$8.value
          }
        };
}

function translation_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var product_id = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "product_id"), null));
  if (product_id.TAG === /* Ok */0) {
    var language_code = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "language_code"), null));
    if (language_code.TAG === /* Ok */0) {
      var name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "name"), null));
      if (name.TAG === /* Ok */0) {
        var description = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "description"), null));
        if (description.TAG === /* Ok */0) {
          var created_at = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "created_at"), null));
          if (created_at.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      product_id: product_id._0,
                      language_code: language_code._0,
                      name: name._0,
                      description: description._0,
                      created_at: created_at._0
                    }
                  };
          }
          var e = created_at._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".created_at" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
        }
        var e$1 = description._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".description" + e$1.path,
                  message: e$1.message,
                  value: e$1.value
                }
              };
      }
      var e$2 = name._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".name" + e$2.path,
                message: e$2.message,
                value: e$2.value
              }
            };
    }
    var e$3 = language_code._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".language_code" + e$3.path,
              message: e$3.message,
              value: e$3.value
            }
          };
  }
  var e$4 = product_id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".product_id" + e$4.path,
            message: e$4.message,
            value: e$4.value
          }
        };
}

function image_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var product_id = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "product_id"), null));
  if (product_id.TAG === /* Ok */0) {
    var image_url = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "image_url"), null));
    if (image_url.TAG === /* Ok */0) {
      var display_order = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "display_order"), null));
      if (display_order.TAG === /* Ok */0) {
        var created_at = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "created_at"), null));
        if (created_at.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    product_id: product_id._0,
                    image_url: image_url._0,
                    display_order: display_order._0,
                    created_at: created_at._0
                  }
                };
        }
        var e = created_at._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".created_at" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = display_order._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".display_order" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = image_url._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".image_url" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = product_id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".product_id" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function variant_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var product_id = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "product_id"), null));
  if (product_id.TAG === /* Ok */0) {
    var sku = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "sku"), null));
    if (sku.TAG === /* Ok */0) {
      var size_code = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "size_code"), null));
      if (size_code.TAG === /* Ok */0) {
        var stock_quantity = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "stock_quantity"), null));
        if (stock_quantity.TAG === /* Ok */0) {
          var is_active = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "is_active"), null));
          if (is_active.TAG === /* Ok */0) {
            var created_at = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "created_at"), null));
            if (created_at.TAG === /* Ok */0) {
              var updated_at = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "updated_at"), null));
              if (updated_at.TAG === /* Ok */0) {
                return {
                        TAG: /* Ok */0,
                        _0: {
                          product_id: product_id._0,
                          sku: sku._0,
                          size_code: size_code._0,
                          stock_quantity: stock_quantity._0,
                          is_active: is_active._0,
                          created_at: created_at._0,
                          updated_at: updated_at._0
                        }
                      };
              }
              var e = updated_at._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".updated_at" + e.path,
                        message: e.message,
                        value: e.value
                      }
                    };
            }
            var e$1 = created_at._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".created_at" + e$1.path,
                      message: e$1.message,
                      value: e$1.value
                    }
                  };
          }
          var e$2 = is_active._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".is_active" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
        }
        var e$3 = stock_quantity._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".stock_quantity" + e$3.path,
                  message: e$3.message,
                  value: e$3.value
                }
              };
      }
      var e$4 = size_code._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".size_code" + e$4.path,
                message: e$4.message,
                value: e$4.value
              }
            };
    }
    var e$5 = sku._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".sku" + e$5.path,
              message: e$5.message,
              value: e$5.value
            }
          };
  }
  var e$6 = product_id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".product_id" + e$6.path,
            message: e$6.message,
            value: e$6.value
          }
        };
}

function priceOverride_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var product_id = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "product_id"), null));
  if (product_id.TAG === /* Ok */0) {
    var geo_region_id = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "geo_region_id"), null));
    if (geo_region_id.TAG === /* Ok */0) {
      var list_amount_minor = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "list_amount_minor"), null));
      if (list_amount_minor.TAG === /* Ok */0) {
        var sale_amount_minor = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "sale_amount_minor"), null));
        if (sale_amount_minor.TAG === /* Ok */0) {
          var currency_code = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "currency_code"), null));
          if (currency_code.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      product_id: product_id._0,
                      geo_region_id: geo_region_id._0,
                      list_amount_minor: list_amount_minor._0,
                      sale_amount_minor: sale_amount_minor._0,
                      currency_code: currency_code._0
                    }
                  };
          }
          var e = currency_code._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".currency_code" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
        }
        var e$1 = sale_amount_minor._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".sale_amount_minor" + e$1.path,
                  message: e$1.message,
                  value: e$1.value
                }
              };
      }
      var e$2 = list_amount_minor._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".list_amount_minor" + e$2.path,
                message: e$2.message,
                value: e$2.value
              }
            };
    }
    var e$3 = geo_region_id._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".geo_region_id" + e$3.path,
              message: e$3.message,
              value: e$3.value
            }
          };
  }
  var e$4 = product_id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".product_id" + e$4.path,
            message: e$4.message,
            value: e$4.value
          }
        };
}

function supplier_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "name"), null));
  if (name.TAG === /* Ok */0) {
    var cashfree_vendor_id = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "cashfree_vendor_id"), null));
    if (cashfree_vendor_id.TAG === /* Ok */0) {
      var is_active = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "is_active"), null));
      if (is_active.TAG === /* Ok */0) {
        var created_at = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "created_at"), null));
        if (created_at.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    name: name._0,
                    cashfree_vendor_id: cashfree_vendor_id._0,
                    is_active: is_active._0,
                    created_at: created_at._0
                  }
                };
        }
        var e = created_at._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".created_at" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = is_active._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".is_active" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = cashfree_vendor_id._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".cashfree_vendor_id" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = name._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".name" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function availability_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var product_id = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "product_id"), null));
  if (product_id.TAG === /* Ok */0) {
    var supplier_id = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "supplier_id"), null));
    if (supplier_id.TAG === /* Ok */0) {
      var supplier = supplier_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "supplier"), null));
      if (supplier.TAG === /* Ok */0) {
        var geo_region_id = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "geo_region_id"), null));
        if (geo_region_id.TAG === /* Ok */0) {
          var is_active = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "is_active"), null));
          if (is_active.TAG === /* Ok */0) {
            var priority = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "priority"), null));
            if (priority.TAG === /* Ok */0) {
              var created_at = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "created_at"), null));
              if (created_at.TAG === /* Ok */0) {
                var updated_at = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "updated_at"), null));
                if (updated_at.TAG === /* Ok */0) {
                  return {
                          TAG: /* Ok */0,
                          _0: {
                            product_id: product_id._0,
                            supplier_id: supplier_id._0,
                            supplier: supplier._0,
                            geo_region_id: geo_region_id._0,
                            is_active: is_active._0,
                            priority: priority._0,
                            created_at: created_at._0,
                            updated_at: updated_at._0
                          }
                        };
                }
                var e = updated_at._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".updated_at" + e.path,
                          message: e.message,
                          value: e.value
                        }
                      };
              }
              var e$1 = created_at._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".created_at" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                      }
                    };
            }
            var e$2 = priority._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".priority" + e$2.path,
                      message: e$2.message,
                      value: e$2.value
                    }
                  };
          }
          var e$3 = is_active._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".is_active" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
        }
        var e$4 = geo_region_id._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".geo_region_id" + e$4.path,
                  message: e$4.message,
                  value: e$4.value
                }
              };
      }
      var e$5 = supplier._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".supplier" + e$5.path,
                message: e$5.message,
                value: e$5.value
              }
            };
    }
    var e$6 = supplier_id._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".supplier_id" + e$6.path,
              message: e$6.message,
              value: e$6.value
            }
          };
  }
  var e$7 = product_id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".product_id" + e$7.path,
            message: e$7.message,
            value: e$7.value
          }
        };
}

function validationTarget_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var target_id = Decco.optionFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "target_id"), null));
  if (target_id.TAG === /* Ok */0) {
    var target_type = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "target_type"), null));
    if (target_type.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                target_id: target_id._0,
                target_type: target_type._0
              }
            };
    }
    var e = target_type._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".target_type" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = target_id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".target_id" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function validationConfig_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var max_allowed_count = Decco.optionFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "max_allowed_count"), null));
  if (max_allowed_count.TAG === /* Ok */0) {
    var rolling_window_days = Decco.optionFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "rolling_window_days"), null));
    if (rolling_window_days.TAG === /* Ok */0) {
      var required_product_id = Decco.optionFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "required_product_id"), null));
      if (required_product_id.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  max_allowed_count: max_allowed_count._0,
                  rolling_window_days: rolling_window_days._0,
                  required_product_id: required_product_id._0
                }
              };
      }
      var e = required_product_id._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".required_product_id" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = rolling_window_days._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".rolling_window_days" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = max_allowed_count._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".max_allowed_count" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function validation_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var target = validationTarget_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "target"), null));
  if (target.TAG === /* Ok */0) {
    var validation_type = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "validation_type"), null));
    if (validation_type.TAG === /* Ok */0) {
      var scope = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "scope"), null));
      if (scope.TAG === /* Ok */0) {
        var geo_region_id = Decco.optionFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "geo_region_id"), null));
        if (geo_region_id.TAG === /* Ok */0) {
          var config = validationConfig_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "config"), null));
          if (config.TAG === /* Ok */0) {
            var is_active = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "is_active"), null));
            if (is_active.TAG === /* Ok */0) {
              var created_at = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "created_at"), null));
              if (created_at.TAG === /* Ok */0) {
                var updated_at = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "updated_at"), null));
                if (updated_at.TAG === /* Ok */0) {
                  return {
                          TAG: /* Ok */0,
                          _0: {
                            target: target._0,
                            validation_type: validation_type._0,
                            scope: scope._0,
                            geo_region_id: geo_region_id._0,
                            config: config._0,
                            is_active: is_active._0,
                            created_at: created_at._0,
                            updated_at: updated_at._0
                          }
                        };
                }
                var e = updated_at._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".updated_at" + e.path,
                          message: e.message,
                          value: e.value
                        }
                      };
              }
              var e$1 = created_at._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".created_at" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                      }
                    };
            }
            var e$2 = is_active._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".is_active" + e$2.path,
                      message: e$2.message,
                      value: e$2.value
                    }
                  };
          }
          var e$3 = config._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".config" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
        }
        var e$4 = geo_region_id._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".geo_region_id" + e$4.path,
                  message: e$4.message,
                  value: e$4.value
                }
              };
      }
      var e$5 = scope._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".scope" + e$5.path,
                message: e$5.message,
                value: e$5.value
              }
            };
    }
    var e$6 = validation_type._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".validation_type" + e$6.path,
              message: e$6.message,
              value: e$6.value
            }
          };
  }
  var e$7 = target._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".target" + e$7.path,
            message: e$7.message,
            value: e$7.value
          }
        };
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var product = product_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "product"), null));
  if (product.TAG === /* Ok */0) {
    var translations = Decco.arrayFromJson(translation_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "translations"), null));
    if (translations.TAG === /* Ok */0) {
      var images = Decco.arrayFromJson(image_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "images"), null));
      if (images.TAG === /* Ok */0) {
        var variants = Decco.arrayFromJson(variant_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "variants"), null));
        if (variants.TAG === /* Ok */0) {
          var price_overrides = Decco.arrayFromJson(priceOverride_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "price_overrides"), null));
          if (price_overrides.TAG === /* Ok */0) {
            var availability = Decco.arrayFromJson(availability_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "availability"), null));
            if (availability.TAG === /* Ok */0) {
              var validations = Decco.arrayFromJson(validation_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "validations"), null));
              if (validations.TAG === /* Ok */0) {
                return {
                        TAG: /* Ok */0,
                        _0: {
                          product: product._0,
                          translations: translations._0,
                          images: images._0,
                          variants: variants._0,
                          price_overrides: price_overrides._0,
                          availability: availability._0,
                          validations: validations._0
                        }
                      };
              }
              var e = validations._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".validations" + e.path,
                        message: e.message,
                        value: e.value
                      }
                    };
            }
            var e$1 = availability._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".availability" + e$1.path,
                      message: e$1.message,
                      value: e$1.value
                    }
                  };
          }
          var e$2 = price_overrides._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".price_overrides" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
        }
        var e$3 = variants._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".variants" + e$3.path,
                  message: e$3.message,
                  value: e$3.value
                }
              };
      }
      var e$4 = images._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".images" + e$4.path,
                message: e$4.message,
                value: e$4.value
              }
            };
    }
    var e$5 = translations._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".translations" + e$5.path,
              message: e$5.message,
              value: e$5.value
            }
          };
  }
  var e$6 = product._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".product" + e$6.path,
            message: e$6.message,
            value: e$6.value
          }
        };
}

export {
  product_decode ,
  translation_decode ,
  image_decode ,
  variant_decode ,
  priceOverride_decode ,
  supplier_decode ,
  availability_decode ,
  validationTarget_decode ,
  validationConfig_decode ,
  validation_decode ,
  t_decode ,
  
}
/* No side effect */
